/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    Gnoment,
    gnomentToCalendarDate,
    rangeValueToGnomentRange,
    calendarDateToGnoment,
} from 'shared-ui/gnoment';

import { DateRangePicker } from 'sarsaparilla';

import { permitSeasonInfoProps, availabilityProps } from '../../props/date-picker';
import { availabilitySelector } from '../../containers/single-date-picker-calendar';
import {
    isDayBlocked as isDayBlockedUtils,
    parsePermitSeasonInfo,
} from '../../utils/availability-utils-scratch';

const propTypes = {
    initialVisibleMonth: PropTypes.instanceOf(Gnoment),
    blockFilter: PropTypes.func,
    blockLotteryDates: PropTypes.bool,
    blockNonLotteryDates: PropTypes.bool,

    // stored dates & change date
    dateRangeStart: PropTypes.instanceOf(Gnoment),
    dateRangeEnd: PropTypes.instanceOf(Gnoment),
    onDatesChange: PropTypes.func, // format: ({ startDate, endDate }) => {}

    // added by redux
    permitSeasonInfo: permitSeasonInfoProps,
    currentDate: PropTypes.instanceOf(Gnoment),
    availability: availabilityProps,
    isRequired: PropTypes.bool,
};

export function DateRangePickerCalendar({
    blockFilter,
    currentDate,
    blockNonLotteryDates,
    blockLotteryDates,
    availability,
    permitSeasonInfo,
    dateRangeStart,
    dateRangeEnd,
    onDatesChange,
    initialVisibleMonth,
    isRequired = false,
}) {
    const isDayBlocked = (day) => {
        return (
            blockFilter(day) ||
            isDayBlockedUtils(
                day,
                permitSeasonInfo,
                currentDate,
                blockNonLotteryDates,
                blockLotteryDates,
                availability.bools
            )
        );
    };

    const getDayType = (day) => {
        if (isDayBlocked(day)) {
            return 'blocked';
        }
        return 'available';
    };

    let datePickerValue = null;

    if (dateRangeStart && dateRangeEnd) {
        datePickerValue = {
            start: gnomentToCalendarDate(dateRangeStart, { useUtc: true }),
            end: gnomentToCalendarDate(dateRangeEnd, { useUtc: true }),
        };
    }

    return (
        <DateRangePicker
            label="Date Range Picker"
            isLabelVisible={false}
            isRequired={isRequired}
            placeholderValue={
                initialVisibleMonth
                    ? gnomentToCalendarDate(initialVisibleMonth.utc())
                    : null
            }
            onChange={(value) =>
                onDatesChange(rangeValueToGnomentRange(value, { useUtc: true }))
            }
            value={datePickerValue}
            getDayType={(value) =>
                getDayType(calendarDateToGnoment(value, { useUtc: true }))
            }
            isDateUnavailable={(value) =>
                isDayBlocked(calendarDateToGnoment(value, { useUtc: true }))
            }
        />
    );
}

function mapStateToProps(state, ownProps) {
    const permit = state.permit.result;
    const aggSeasonRules = state.permit.agg_season_rules;
    const availability = availabilitySelector(state, permit.id, ownProps.divisionId);
    const permitSeasonInfo = parsePermitSeasonInfo(
        aggSeasonRules,
        permit.time_zone,
        ownProps.divisionId,
        permit.rules
    );

    return {
        blockLotteryDates: ownProps.blockLotteryDates,
        permitSeasonInfo,
        availability,
    };
}

DateRangePickerCalendar.propTypes = propTypes;

export default connect(mapStateToProps)(DateRangePickerCalendar);
